import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { ContentCard } from 'components/Card';
import { getTrans } from 'modules/i18n';
import { CVBuilderFormValues, EducationEntry } from 'utils/cv-form-db';
import { StepProgressIndicator } from '../../components/StepProgressIndicator';
import { EducationDetailsList } from './EducationDetailsList';
import { EducationForm } from './EducationForm';

interface EducationContentProps {
  isFormOpen: boolean;
  isEditing: boolean;
  editingItem: EducationEntry | null;
  onAdd: (item: EducationEntry) => void;
  onEdit: (item: EducationEntry) => void;
  onCancel: () => void;
  onAddClick: () => void;
  onEditClick: (index: number) => void;
  onDeleteClick: (index: number) => void;
}

export const EducationContent = ({
  isFormOpen,
  isEditing,
  editingItem,
  onAdd,
  onEdit,
  onCancel,
  onAddClick,
  onEditClick,
  onDeleteClick
}: EducationContentProps) => {
  const { values } = useFormikContext<CVBuilderFormValues>();

  return (
    <>
      <ContentCard
        title={getTrans('cvBuilderPage.education.title')}
        titleVariant="h4"
      >
        <Box sx={{ mb: 2 }}>
          <StepProgressIndicator
            showPercentage={true}
            size="medium"
            variant="compact"
          />
        </Box>
      </ContentCard>
      {isFormOpen ? (
        <EducationForm
          mode={isEditing ? 'edit' : 'add'}
          initialValues={editingItem || undefined}
          onSubmit={isEditing ? onEdit : onAdd}
          onCancel={onCancel}
        />
      ) : (
        <EducationDetailsList
          values={values}
          onAddClick={onAddClick}
          onEditEducation={onEditClick}
          onDeleteEducation={onDeleteClick}
        />
      )}
    </>
  );
};
